import { forwardRef } from "react";

export interface KeepsakeData {
  oneLine: string;
  letter?: string; // 토글 ON일 때만 편지 포함.
  prophecy?: { text: string; caption?: string }; // 편지 포함 시 예언도 함께.
}

// 키프세이크 카드 — 추출(이미지) 대상. 앞면 = 보편적 한 마디. 편지·예언 포함은 옵트인.
const KeepsakeCard = forwardRef<HTMLDivElement, { data: KeepsakeData }>(({ data }, ref) => {
  return (
    <div className="keepsake" ref={ref}>
      <div className="keepsake-glow" />
      <div className="keepsake-line">{data.oneLine}</div>
      {data.letter && <div className="keepsake-letter">{data.letter}</div>}
      {data.prophecy && (
        <div className="keepsake-proph">
          <div className="keepsake-proph-text">✦ {data.prophecy.text}</div>
          {data.prophecy.caption && <div className="keepsake-proph-cap">{data.prophecy.caption}</div>}
        </div>
      )}
      <div className="keepsake-foot">
        <span className="logo-dot" style={{ width: 12, height: 12 }} />
        <span style={{ fontSize: 11, color: "#9c968b" }}>hyuh</span>
      </div>
    </div>
  );
});
KeepsakeCard.displayName = "KeepsakeCard";
export default KeepsakeCard;
